'use client'

import { useAppDispatch } from 'hooks/redux'
import { useSearchParams } from 'next/navigation'
import { Suspense, useEffect } from 'react'
import { setSearchParams } from 'redux/slices/searchParams'

const GetSearchParamsComponent = () => {
  const searchParams = useSearchParams()
  const dispatch = useAppDispatch()

  useEffect(() => {
    const searchParamsObject = {}

    searchParams.forEach((value, key) => {
      searchParamsObject[key] = value
    })

    dispatch(setSearchParams(searchParamsObject))
  }, [searchParams, dispatch])

  return null
}

const GetSearchParams = () => {
  return (
    <Suspense fallback={null}>
      <GetSearchParamsComponent />
    </Suspense>
  )
}

export default GetSearchParams
